import { Position } from "@/services/backend/rlt/treatments/types/position";
import { cn } from "@/shared/lib/utils";
import { fCleanTime } from "@/services/backend/rlt/treatments/lib/utils";

export function CleanTimeCell({
  position,
  className = "",
}: {
  position: Position;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-6 items-center justify-end font-bold whitespace-nowrap",
        className,
      )}
    >
      {fCleanTime(position.cleanTime)}
    </div>
  );
}
